module.exports = __webpack_public_path__ + "media/images/haircut/laura-5c941e6894b7bea7feb6c869823d554e.jpg";